import { render, staticRenderFns } from "./related-links.vue?vue&type=template&id=69325501&scoped=true&"
import script from "./related-links.vue?vue&type=script&lang=js&"
export * from "./related-links.vue?vue&type=script&lang=js&"
import style0 from "./related-links.vue?vue&type=style&index=0&id=69325501&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69325501",
  null
  
)

export default component.exports